import React, { Fragment, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isRenderedAdUnit } from 'client/utils/ads';
import { NativeAd } from 'site-modules/shared/components/ad-unit/native-ad';

/**
 * VdpAdUnit component.
 * @returns {ReactElement}
 */
export function VdpAdUnit({ position = '1' }) {
  const [isLoaded, setLoaded] = useState(false);

  const slotRenderEndListener = useCallback(slotObj => {
    setLoaded(isRenderedAdUnit(slotObj));
  }, []);

  return (
    <Fragment>
      <div className={classnames('d-flex justify-content-center', { 'my-3_5': isLoaded })}>
        <NativeAd
          position={position}
          wrapperClass="mrect mx-auto"
          adNameWired="mrect"
          adNameMobile="mmrect"
          nativeStyle="mediumrectangle"
          showLabel
          slotRenderEndListener={slotRenderEndListener}
        />
      </div>
    </Fragment>
  );
}

VdpAdUnit.propTypes = {
  position: PropTypes.string,
};
